/* tslint:disable */
const MIN_LOADER_TIME = 500;

class TimeoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TimeoutError';
  }
}

class MinTimer {
  public onComplete: ((val: any) => any) | undefined;
  public onError: ((err: Error) => any) | undefined;

  private minTime: number;
  private timeout: number | undefined;
  private tasks: any[];
  private resolveComplete:
    | ((value?: {} | PromiseLike<{}> | undefined) => void)
    | undefined;
  private waiter: () => Promise<void>;

  /**
   * @param minTime - The minimum amount of time (in milliseconds) to wait before calling onComplete
   * @param timeout - Throw an error after this amount of time has passed (in milliseconds)
   */
  constructor(minTime: number = MIN_LOADER_TIME, timeout?: number) {
    if (timeout && timeout <= minTime) {
      throw new Error('Timeout cannot be larger than minTime');
    }

    this.minTime = minTime;
    this.timeout = timeout;

    this.tasks = [
      () => new Promise(resolve => setTimeout(() => resolve(), this.minTime)),
    ];

    if (this.timeout) {
      this.tasks.push(
        () =>
          new Promise((resolve, reject) =>
            setTimeout(
              () => reject(new TimeoutError('Timer has timed out')),
              this.timeout
            )
          )
      );
    }

    this.waiter = () => {
      return Promise.all(this.tasks.map(t => t()))
        .then(arr => {
          if (this.onComplete) {
            this.onComplete(arr[1]);
          }
        })
        .catch(err => {
          if (this.onError) {
            this.onError(err);
          } else {
            throw err;
          }
        });
    };
  }

  /**
   * Start the timer's countdown
   */
  public start(): void {
    this.tasks.push(
      () =>
        new Promise((resolve, reject) => {
          this.resolveComplete = resolve;
        })
    );

    this.waiter();
  }

  /**
   * Mark the timer promise as complete when the minimum timer is complete
   * @param value - A value to pass to the onComplete function when the timer has completed
   */
  public complete(value: any) {
    if (this.resolveComplete) {
      this.resolveComplete(value);
      return true;
    } else {
      return false;
    }
  }
}

export default MinTimer;
